// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-mode-block[data-v-6bf9f4f2]{background-color:#f5f5f6}.ui-dark .preview-mode-block[data-v-6bf9f4f2]{background-color:#2a2b3a}.success[data-v-6bf9f4f2]{color:#31b486}.success .dot[data-v-6bf9f4f2]{background:#31b486}.dot[data-v-6bf9f4f2]{width:8px;height:8px;border-radius:100%;background:#7e7f88}.ui-dark .btn-simple-secondary[data-v-6bf9f4f2]{border-color:#3e3f4c;background-color:#3e3f4c}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
